import React from 'react';

export const EnlargeIcon = ({ fill = 'white', stroke = '#E5E5E5', pathStroke = 'black', className }) => {
    return (
        <svg
            width={45}
            height={45}
            viewBox="0 0 45 45"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            style={{ display: 'inline-block', verticalAlign: 'middle', transform: 'translateY(7px)' }}
        >
            <g filter="url(#filter0_d_144_1020)">
                <rect x="8" width="29" height="29" rx="6.66" fill={fill} />
                <rect
                    x="8.42531"
                    y="0.425313"
                    width="28.1494"
                    height="28.1494"
                    rx="6.23469"
                    stroke={stroke}
                    strokeWidth="0.850625"
                />
            </g>
            <path
                d="M23 19.0781H28.0781V14M17.9219 14V8.92187H23"
                stroke={pathStroke}
                strokeWidth="1.34654"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <defs>
                <filter
                    id="filter0_d_144_1020"
                    x="0"
                    y="0"
                    width="45"
                    height="45"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feColorMatrix
                        in="SourceAlpha"
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        result="hardAlpha"
                    />
                    <feOffset dy="8" />
                    <feGaussianBlur stdDeviation="4" />
                    <feComposite in2="hardAlpha" operator="out" />
                    <feColorMatrix
                        type="matrix"
                        values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
                    />
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_144_1020" />
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_144_1020" result="shape" />
                </filter>
            </defs>
        </svg>
    );
};